import { Injectable } from '@angular/core';

import { Query, gql } from 'apollo-angular';

import { Cart, QueryMiniCartArgs } from '@hdms/shared/common-types';

export interface MiniCartResponse {
  miniCart: Cart;
}

@Injectable({
  providedIn: 'root'
})
export class MiniCartGqlService extends Query<MiniCartResponse, QueryMiniCartArgs> {
  override document = gql`
    query MiniCart($id: ID!) {
      miniCart(id: $id) {
        id
        numberOfItems
      }
    }
  `;
}
